import { IStepOrderTableReport } from "../../../../Interfaces/stepInterfaces";
import { getSubOrderChances } from "../../../../Requests/stepRequests";
import { CommonTableUI } from "../../../TableTemplate/common";
import TableTemplate from "../../../TableTemplate/tableTemplate";

interface ISubOrderChancesTableProps {
  shekarOrderId: number;
}

const SubOrderChancesTable = ({
  shekarOrderId,
}: ISubOrderChancesTableProps) => {
  return (
    <TableTemplate<{ shekarOrderId: number }, IStepOrderTableReport>
      getDataTable={getSubOrderChances}
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      initialSearchParameters={{ shekarOrderId }}
    />
  );
};

export default SubOrderChancesTable;
